<template>
  <!--
    Headerコンポーネント

    画面タイトルやヘルプへのアクセスなどを提供するアプリケーションヘッダです。
    高さや位置の固定は行っていないので、利用する側で調整してください。

    Events
    * moveToMenu: メニューへボタンがクリックされたとき
    * moveToHelp: ヘルプボタンがクリックされたとき
  -->
  <div class="header">
    <div class="left">
      <gl-button @click="$emit('moveToMenu')">メニューへ</gl-button>
    </div>
    <div class="main">
      <div class="title">{{ title }}</div>
    </div>
    <div class="right">
      <div gl-tooltip="ヘルプ" gl-tooltip-direction="down">
        <gl-button icon-button v-if="helpIcon" @click="$emit('moveToHelp')">
          <gl-icon-help />
        </gl-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    /**
     * ヘルプアイコンの表示有無
     *
     * ヘルプ画面など、ヘルプアイコンの表示が不要の場合はfalseを設定してください。
     */
    helpIcon: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  align-items: center;
  display: flex;
  background-color: var(--bg-color-primary);
  left: 0;
  margin-left: var(--spacing-large);
  margin-right: var(--spacing-large);
  width: 100%;

  .main {
    flex: 1;
    // 左右のコンポーネントの幅が固定されている訳ではないので、この中を
    // 中央寄せにしてしまうと画面の中央にならないのでtext-align:centerしていない
  }

  .title {
    font-size: var(--font-size-large);
    margin-left: var(--spacing-large);
  }
}
</style>
